import { timeParse } from "d3";
import { _EVENTS_CHILD_ORDER } from "../../ui/utils/General";
import { apiEscuelaObtenerConfiguracion } from "../API";
import { _APP_DATA } from "../AppData";
import { EEventId, IApiResult, IEvent, IKinder } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export let _ESCUELA: IKinder | null;
const formatHMS = timeParse("%H:%M:%S");

export function _SvEscuelaObtenerConfiguracion(callback: () => void) {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder
    }

    new RequestData<IApiResult<IKinder>>(apiEscuelaObtenerConfiguracion)
        .Params(params)
        .Completion((response, error) => {
            const resultData = response?.Datos || null;

            if (error)
                console.log(error.name, error.message);

            _ESCUELA = resultData;

            if (_ESCUELA) {
                if (_ESCUELA.HoraEntrada)
                    _ESCUELA.DTHoraEntrada = formatHMS(_ESCUELA.HoraEntrada);
                if (_ESCUELA.HoraSalida)
                    _ESCUELA.DTHoraSalida = formatHMS(_ESCUELA.HoraSalida);
            }

            if (callback) callback();
        }).Get();
}


export async function _SvEscuelaObtenerEventosFullArray(): Promise<IEvent[]> {
    if (!_ESCUELA) {
        await new Promise<void>((resolve) => _SvEscuelaObtenerConfiguracion(() => resolve()));
        if (!_ESCUELA) return [];
    }

    return _EVENTS_CHILD_ORDER
        .map(([_, info]) => info)
        .filter(d => {
            const evEVALTipes = [EEventId.MILLESTONE, EEventId.EVALUATION];
            if (evEVALTipes.includes(d.id)) {
                if (_ESCUELA.ModuloEval)
                    return d.id == _ESCUELA.ModuloEval;
                else
                    return d.id == EEventId.MILLESTONE;
            }
            return true;
        })
}

export async function _SvEscuelaObtenerEventosFullMap(): Promise<Partial<{ [k in EEventId]: IEvent }>> {
    return _SvEscuelaObtenerEventosFullArray()
        .then(evts => evts.reduce((res, d) => {
            res[d.id] = d;
            return res;
        }, {}))
}

export function _SvEscuelaClearKinderData() {
    _ESCUELA = null;
}